// extracted by mini-css-extract-plugin
module.exports = {"announcement":"announcement-bar_announcement__ilP9l","text":"announcement-bar_text__2E3ul"};